import * as XLSX from 'xlsx';

// default Root for URLs
export const rootUrl = (to) => {
    // return "http://luapula.gramosi.org/gramosiBackend" + to;
    // return "http://localhost:8888/gramosiBackend" + to;
    return "/gramosiBackend" + to;
}

// check if email is valid
export const checkEmailValidation = (email) => {
    // Regular expresion for validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export const sumOfArray = (arr) => arr.reduce((acc, num) => acc + num, 0);

export function calculateAge(dob) {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (
        monthDifference < 0 || 
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
        age--;
    }
    return age;
}

export function humanizeString(string) {
    // Replace underscores and hyphens with spaces
    let humanized = string.replace(/[_-]/g, ' ');

    // Convert camelCase to separate words with spaces
    humanized = humanized.replace(/([a-z])([A-Z])/g, '$1 $2');

    // Capitalize the first letter of each word
    humanized = humanized.replace(/\b\w/g, c => c.toUpperCase());

    return humanized;
}

/**
 * Creates a new object containing only the specified keys from the original object.
 * @param {Object} object - The original object.
 * @param {Array} keys - An array of keys to pick from the original object.
 * @returns {Object} - A new object containing only the selected keys from the original object.
 */
export function selectObjectProperties(object, keys) {
    return Object.fromEntries(
        Object.entries(object)
            .filter(([key]) => keys.includes(key))
    );
}

export function formatDate(dateString) {
    const dateObj = new Date(dateString.trim())

    if (dateObj) {
        return dateObj.toDateString()
    }
    return "Invalid date format"
}

// export function formatToZMW (amount) {
//     return new Intl.NumberFormat('en-ZM', { 
//         style: 'currency', 
//         currency: 'ZMW' 
//     }).format(amount);
// };

export function formatToZMW(amount) {
  return new Intl.NumberFormat('en-ZM', { 
      style: 'decimal', 
      minimumFractionDigits: 2,  // Ensures two decimal places
      maximumFractionDigits: 2   // Limits the number of decimals to 2
  }).format(amount);
}


export function numberToWords(amount) {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"
  ];
  const teens = [
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen",
    "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];
  const tens = [
    "", "Ten", "Twenty", "Thirty", "Forty", "Fifty",
    "Sixty", "Seventy", "Eighty", "Ninety"
  ];
  const thousands = [
    "", "Thousand", "Million", "Billion", "Trillion"
  ];

  // Helper function to convert numbers less than 1000 to words
  function convertToWords(num) {
    let word = "";

    if (num > 99) {
      word += `${units[Math.floor(num / 100)]} Hundred `;
      num %= 100;
    }

    if (num > 10 && num < 20) {
      word += `${teens[num - 11]} `;
    } else {
      word += `${tens[Math.floor(num / 10)]} `;
      word += `${units[num % 10]} `;
    }

    return word.trim();
  }

  if (isNaN(amount) || amount === 0) {
    return "Zero";
  }

  let integerPart = Math.floor(amount);
  let decimalPart = Math.round((amount - integerPart) * 100);

  let words = "";
  let i = 0;

  while (integerPart > 0) {
    const chunk = integerPart % 1000;
    if (chunk > 0) {
      words = `${convertToWords(chunk)} ${thousands[i]} ${words}`.trim();
    }
    integerPart = Math.floor(integerPart / 1000);
    i++;
  }

  // Add decimal part (if any)
  if (decimalPart > 0) {
    words += ` and ${convertToWords(decimalPart)} Ngwee`;
  }

  return words.trim();
}

export const handlePrint = (componentRef) => {
  const printContent = componentRef.current;
  const printWindow = window.open("", "", "width=800,height=600");
  printWindow.document.open();
  printWindow.document.write(`
    <html>
      <head>
        <title>Print Page</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          @media print {
            body { margin: 20px; }
          }
        </style>
      </head>
      <body class="p-4">${printContent.innerHTML}</body>
    </html>
  `);
  printWindow.document.close();

  // Ensure Tailwind is applied before printing
  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
};


export const handleExcel = (componentRef, name) => {
      const input = componentRef.current;
      if (!input) return;
      // Extract table or structured data from the ref
      const rows = Array.from(input.querySelectorAll('tr')).map((row) => {
        return Array.from(row.querySelectorAll('th, td')).map((cell) => cell.textContent);
      });
    
      // Create a worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
    
      // Append the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
      // Export the workbook as an Excel file
      XLSX.writeFile(workbook, `${name}.xlsx`);
    }



export const getAllConstituencies = (provinces) => {
  const constituencies = [];
  Object.values(provinces).forEach((province) => {
    Object.values(province.districts).forEach((district) => {
      constituencies.push(...district);
    });
  });
  return constituencies;
};
  

export const  revenueCodesAndNames = [
  { id: "151", name: "LOCAL TAXES" },
  { id: "152", name: "FEES AND CHARGES" },
  { id: "153", name: "LICENCES" },
  { id: "154", name: "LEVIES" },
  { id: "155", name: "PERMITS" },
  { id: "156", name: "CHARGES" },
  { id: "157", name: "OTHER INCOMES" },
  { id: "158", name: "NATIONAL SUPPORT (GRANTS)" },
  { id: "159", name: "DONOR SUPPORT" }
];


export const  expenditureCodesAndNames = [ 
  { id: "211", name: "Salaries" },
  { id: "212", name: "Wages" },
  { id: "213", name: "Allowances" },
  { id: "214", name: "Emolument Expenses" },
  { id: "221", name: "Office Costs" },
  { id: "222", name: "Building, Repair and Maintenance Costs" },
  { id: "223", name: "Plant, Machinery, Vehicle Running and Maintenance Costs" },
  { id: "224", name: "Other Administrative Operating Costs" },
  { id: "225", name: "Requisites" },
  { id: "226", name: "Services" },
  { id: "227", name: "Travel Expenses" },
  { id: "228", name: "Training" },
  { id: "229", name: "Legal Costs" },
  { id: "231", name: "Depreciation on Own Assets" },
  { id: "232", name: "Depreciation on Leased Property (Finance Lease)" },
  { id: "241", name: "Interest on Domestic Debt" },
  { id: "242", name: "Interest on External Debt" },
  { id: "243", name: "Financial Charges" },
  { id: "244", name: "Settlement of Outstanding Bills - Financial Charges" },
  { id: "249", name: "Other Financial Charges" },
  { id: "251", name: "Social Assistance Benefits" },
  { id: "261", name: "Grants to Grant-aided Institutions" },
  { id: "262", name: "Grants to Non-Governmental Organisations" },
  { id: "263", name: "Grants to Households" },
  { id: "264", name: "Grants to Institutional Revolving Funds" },
  { id: "265", name: "Other Grants" },
  { id: "267", name: "Other Payments" },
  { id: "271", name: "Subsidies to Non-Financial Enterprises" },
  { id: "272", name: "Subsidies to Financial Institutions" },
  { id: "273", name: "Subsidies to Private Enterprises" },
  { id: "274", name: "Other Subsidies" },
  { id: "281", name: "Legal Expenses" },
  { id: "291", name: "Constitutional Expenditure" },
  { id: "292", name: "Other Constitutional Expenditure" },
  { id: "293", name: "Allowances" },
  { id: "294", name: "Statutory Expenditure" },
  { id: "295", name: "Other Expenses" },
  { id: "311", name: "Fixed Assets" },
  { id: "312", name: "Stocks (Inventories)" },
  { id: "313", name: "Valuables" },
  { id: "314", name: "Non-Produced Assets" },
  { id: "320", name: "Long Term Investments" },
  { id: "321", name: "Debtors" },
  { id: "322", name: "Staff Debtors" },
  { id: "323", name: "Prepayments" },
  { id: "324", name: "VAT refunds" },
  { id: "325", name: "Foreign Debtors" },
  { id: "326", name: "Cash and Cash Equivalents" },
  { id: "411", name: "Creditors" },
  { id: "421", name: "Creditors" },
  { id: "520", name: "Current Year Surplus/(Deficit)" },
  { id: "530", name: "Reserves" },
  { id: "611", name: "Realised Gains/Losses" },
  { id: "621", name: "Unrealised Gains/Losses" },
  { id: "631", name: "Miscellaneous" },
  { id: "510", name: "Owners Fund" },
  { id: "000", name: "Rest" },

]
